module.exports = __webpack_public_path__ + "static/media/notification-audio.2aebb5ce.mp3";